import React from "react";
import { Box, Button, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Title from "../title";
import { useThemeMode } from "@/colors";

export const HeroCTA: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { mode } = useThemeMode();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      mt={isSmall ? "32px" : isMobile ? "64px" : "128px"}
      maxWidth="80%"
      textAlign="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="32px"
      mb="20vh"
    >
      <Title center spacing="32px" titleSize={isMobile ? "64px" : "80px"}/>
      <Button variant="contained" fullWidth onClick={() => navigate("/create")} sx={{ maxWidth: "600px", py: "8px", mt: "24px", mb: "196px", fontSize: "24px !important", boxShadow: mode === "light" ? "6px 6px #808080" : undefined }}> Create your map</Button>
    </Box>
  );
};
